/* ============================================
   NIJII - Custom JavaScript
   Intersection Observer Animations & Interactions
   ============================================ */

(function() {
  'use strict';

  /* ---- Intersection Observer for Reveal Animations ---- */
  function initRevealAnimations() {
    var revealElements = document.querySelectorAll(
      '.nijii-reveal, .nijii-reveal--left, .nijii-reveal--right, .nijii-reveal--scale, .nijii-stagger, .nijii-hero'
    );

    if (!revealElements.length) return;

    var observerOptions = {
      root: null,
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.15
    };

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          /* Unobserve once animated to save resources */
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    revealElements.forEach(function(el) {
      observer.observe(el);
    });
  }

  /* ---- Parallax Scroll Effect for Hero ---- */
  function initParallaxHero() {
    var hero = document.querySelector('.nijii-hero');
    if (!hero) return;

    var heroMedia = hero.querySelector('.nijii-hero__media img, .nijii-hero__media video');
    if (!heroMedia) return;

    var ticking = false;

    function updateParallax() {
      var scrolled = window.pageYOffset;
      var heroHeight = hero.offsetHeight;

      if (scrolled < heroHeight) {
        var translateY = scrolled * 0.3;
        heroMedia.style.transform = 'scale(1.05) translateY(' + translateY + 'px)';
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---- Smooth Header Background on Scroll ---- */
  function initHeaderScroll() {
    var header = document.querySelector('.section-header');
    if (!header) return;

    var lastScroll = 0;
    var ticking = false;

    function updateHeader() {
      var scrolled = window.pageYOffset;
      if (scrolled > 80) {
        header.classList.add('nijii-header-scrolled');
      } else {
        header.classList.remove('nijii-header-scrolled');
      }
      lastScroll = scrolled;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---- Lotus Icon Hover Animation ---- */
  function initLotusAnimations() {
    var lotusIcons = document.querySelectorAll('.nijii-lotus-animated');
    lotusIcons.forEach(function(icon) {
      icon.addEventListener('mouseenter', function() {
        this.style.animation = 'lotusPulse 0.8s ease-in-out';
      });
      icon.addEventListener('animationend', function() {
        this.style.animation = '';
      });
    });
  }

  /* ---- Collection Card Tilt Effect (Desktop Only) ---- */
  function initCardTilt() {
    if (window.innerWidth < 1025) return;

    var cards = document.querySelectorAll('.nijii-collection-card');
    cards.forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var rotateX = (y - centerY) / centerY * -3;
        var rotateY = (x - centerX) / centerX * 3;

        card.style.transform = 'perspective(1000px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
      });

      card.addEventListener('mouseleave', function() {
        card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0)';
        card.style.transition = 'transform 0.5s ease-out';
      });

      card.addEventListener('mouseenter', function() {
        card.style.transition = 'transform 0.1s ease-out';
      });
    });
  }

  /* ---- Marquee Pause on Hover ---- */
  function initMarquee() {
    var marquee = document.querySelector('.nijii-marquee');
    if (!marquee) return;

    var track = marquee.querySelector('.nijii-marquee__track');
    if (!track) return;

    marquee.addEventListener('mouseenter', function() {
      track.style.animationPlayState = 'paused';
    });

    marquee.addEventListener('mouseleave', function() {
      track.style.animationPlayState = 'running';
    });
  }

  /* ---- Newsletter Form Animation ---- */
  function initNewsletter() {
    var form = document.querySelector('.nijii-newsletter__form');
    if (!form) return;

    var input = form.querySelector('.nijii-newsletter__input');
    var btn = form.querySelector('.nijii-newsletter__btn');

    if (input) {
      input.addEventListener('focus', function() {
        form.classList.add('nijii-newsletter__form--focused');
      });

      input.addEventListener('blur', function() {
        form.classList.remove('nijii-newsletter__form--focused');
      });
    }
  }

  /* ---- Smooth Scroll for Anchor Links ---- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;

        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          var headerHeight = document.querySelector('.section-header') ?
            document.querySelector('.section-header').offsetHeight : 0;

          window.scrollTo({
            top: target.offsetTop - headerHeight,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  /* ---- Counter Animation for Stats ---- */
  function initCounters() {
    var counters = document.querySelectorAll('[data-nijii-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute('data-nijii-counter'), 10);
          var duration = 2000;
          var start = 0;
          var startTime = null;

          function animate(currentTime) {
            if (!startTime) startTime = currentTime;
            var progress = Math.min((currentTime - startTime) / duration, 1);
            var easeOut = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.floor(easeOut * target);
            if (progress < 1) {
              requestAnimationFrame(animate);
            } else {
              el.textContent = target;
            }
          }

          requestAnimationFrame(animate);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(counter) {
      observer.observe(counter);
    });
  }

  /* ---- Initialize All ---- */
  function init() {
    initRevealAnimations();
    initParallaxHero();
    initHeaderScroll();
    initLotusAnimations();
    initCardTilt();
    initMarquee();
    initNewsletter();
    initSmoothScroll();
    initCounters();
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init on Shopify section load (Theme Editor) */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(init, 100);
    });
  }
})();
